import React from 'react';

export default function StyledSelect({ icon: Icon, value, onChange, options, className = '' }) {
  return (
    <div className={`relative flex items-center ${className}`}>
      {Icon && (
        <Icon className="absolute left-2.5 h-4 w-4 text-gray-400 dark:text-gray-500 pointer-events-none" />
      )}
      <select
        value={value}
        onChange={onChange}
        className={`w-full text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-surface dark:bg-gray-870 font-medium text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-600 focus:border-brand-500 focus:ring-1 focus:ring-brand-500 py-2 pr-3 ${Icon ? 'pl-8' : 'pl-3'}`}
      >
        {options.map(({ value: optValue, label }) => (
          <option key={optValue} value={optValue}>{label}</option>
        ))}
      </select>
    </div>
  );
}
